(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("F2"), require("G2"), require("React"), require("ReactDOM"), require("_"), require("antd"));
	else if(typeof define === 'function' && define.amd)
		define(["F2", "G2", "React", "ReactDOM", "_", "antd"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("F2"), require("G2"), require("React"), require("ReactDOM"), require("_"), require("antd")) : factory(root["F2"], root["G2"], root["React"], root["ReactDOM"], root["_"], root["antd"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__4352__, __WEBPACK_EXTERNAL_MODULE__2331__, __WEBPACK_EXTERNAL_MODULE__1024__, __WEBPACK_EXTERNAL_MODULE__314__, __WEBPACK_EXTERNAL_MODULE__9479__, __WEBPACK_EXTERNAL_MODULE__2721__) => {
return 